class MarketPlaceEntity {
  constructor({ ...data }) {
    this.Id = data?.Id || '';
    this.Name = data?.Name || '';
    this.Warehouses = Object.keys(data?.Warehouses) || [];
    this.PriceTypeCurrency = data?.PriceTypeCurrency || '';
  }
}

export default MarketPlaceEntity;
